<template>
  <div>
    <div class="position-relative">
      <section class="section-shaped my-0">
        <bubbles-background></bubbles-background>
        <div class="container container-lg pb-4 shape-container">
          <card shadow class="card-profile mt-4 border-0" no-body>
            <vertical-ptwist-modules></vertical-ptwist-modules>
            <card-header title="Influencers" :icon="{prefix:'fas', iconName: 'users'}" prefix="fas"
                         :text="pageText"></card-header>
            <div class="px-4 pb-3">
              <div class="mb-3 row">
                <div class="col-md-12">
                  <base-button tag="a"
                               class="mb-3 mb-sm-0"
                               type="button"
                               @click="changeSource('inferred')"
                               :class="[ source === 'inferred' ? 'bg-blue text-white' : 'bg-secondary text-black-50']"
                               :icon="{ prefix: 'fas', iconName: 'cogs'}">
                    Inferred
                  </base-button>
                  <base-button tag="a"
                               class="mb-3 mb-sm-0"
                               type="button"
                               @click="changeSource('provided')"
                               :class="[ source === 'provided' ? 'bg-blue text-white' : 'bg-secondary text-black-50']"
                               :icon="{ prefix: 'fas', iconName: 'drafting-compass'}">
                    Provided by pilots
                  </base-button>
                </div>
              </div>
              <div v-if="source === 'inferred'">
                <div class="row" v-if="source === 'inferred'">
                  <div class="col-md-4 col-sm-12">
                    <small class="d-block text-uppercase font-weight-bold mb-3">Month</small>
                    <vue-monthly-picker
                      v-on:selected="monthSelected"
                      dateFormat="MMMM, YYYY"
                      :min="minMonth"
                      :max="maxMonth"
                      :monthLabels="monthLabels"
                      v-model="month">
                    </vue-monthly-picker>
                  </div>
                  <div class="col-md-4 col-sm-12">
                    <collections-select v-model="collection" alternative
                                        label="Collection"></collections-select>
                  </div>
                  <div class="col-md-4 col-sm-12">
                    <language-select alternative label="Language"></language-select>
                  </div>
                </div>

                <div class="mb-3 row">
                  <div class="col-md-12">
                    <small class="d-block text-uppercase font-weight-bold mb-3">Algorithm</small>

                    <base-button
                      class="mb-3 mb-sm-0"
                      size="sm"
                      type="button"
                      @click="changeAlgorithm('betweenness_centrality')"
                      :class="[ algorithm === 'betweenness_centrality' ? 'bg-ptwist text-white' : 'bg-secondary text-black-50']"
                      :icon="{ prefix: 'fas', iconName: 'dot-circle'}">
                      Betweenness Centrality
                    </base-button>
                    <base-button tag="a"
                                 class="mb-3 mb-sm-0"
                                 size="sm"
                                 type="button"
                                 @click="changeAlgorithm('netshield')"
                                 :class="[ algorithm === 'netshield' ? 'bg-ptwist text-white' : 'bg-secondary text-black-50']"
                                 :icon="{ prefix: 'fas', iconName: 'shield-alt'}">
                      NetShield
                    </base-button>
                  </div>
                </div>
              </div>
              <div v-if="influencers">
                <div v-if="source === 'inferred'">
                  <influencers-masonry
                    :influencers="algorithm === 'betweenness_centrality' ? influencers.betweenness_centrality : influencers.netshield"></influencers-masonry>
                </div>
                <div v-else>
                  <influencers-masonry
                    :influencers="influencers"></influencers-masonry>
                </div>
              </div>
              <ptwist-loading v-else-if="loading"></ptwist-loading>
              <server-error v-else-if="error"></server-error>
              <no-data-error v-else>
              </no-data-error>
            </div>
          </card>
        </div>
      </section>
    </div>
  </div>
</template>

<script>

import { Bus } from '../bus'
import moment from 'moment'
import VueMonthlyPicker from 'vue-monthly-picker'
import { getInfoText } from '../info'
import VerticalPtwistModules from '@/components/VerticalPtwistModules.vue'

export default {
  name: 'influencers',
  components: { 'vue-monthly-picker': VueMonthlyPicker, VerticalPtwistModules },
  data () {
    return {
      collection: 'plastic_pollution',
      language: 'en',
      error: false,
      loading: true,
      monthLabels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      algorithm: 'betweenness_centrality',
      minMonth: moment('2-14-2018', 'MM-DD-YYYY'),
      maxMonth: moment('09-30-2020', 'MM-DD-YYYY'),
      month: moment('09-01-2020', 'MM-DD-YYYY'),
      source: 'inferred',
      pageText: getInfoText('influencers'),
      influencers: null
    }
  },
  mounted () {
    this.updateInfluencers()
  },
  methods: {
    getEndpoint () {
      if (this.source === 'inferred') {
        return 'twitter/influencers'
      } else {
        return 'plastictwist/influencers'
      }
    },
    getData () {
      if (this.source === 'inferred') {
        return {
          collection: this.collection,
          language: this.language,
          timestamp: this.month.endOf('month').unix() * 1000
        }
      } else return {}
    },
    changeSource (source) {
      this.source = source
      this.updateInfluencers()
    },
    changeAlgorithm (algorithm) {
      this.algorithm = algorithm
    },
    updateInfluencers () {
      this.loading = true
      this.error = false
      this.influencers = null
      let payload = {
        data: this.getData(),
        endpoint: this.getEndpoint()
      }
      this.$store
        .dispatch('api/get', payload)
        .then(response => {
          this.influencers = response.data
          this.loading = false
        }).catch(error => {
          console.error(error)
          this.error = true
          this.loading = false
        })
    },
    monthSelected () {
      this.updateInfluencers()
    }

  },
  watch: {

    collection () {
      this.updateInfluencers()
    },
    language () {
      this.updateInfluencers()
    }
  },
  created () {
    Bus.$on('new-language', function (newLanguage) {
      this.language = newLanguage
      Bus.$emit('new-collections', this.language)
    }.bind(this))
    Bus.$on('new-collection', function (newCollection) {
      this.collection = newCollection
    }.bind(this))
  }

}
</script>
<style>
  .vue-monthly-picker .input {
    display: block;
    width: 100%;
    height: calc(2.75rem + 2px) !important;
    padding: 0.725rem 0.75rem !important;
    font-size: 0.875rem !important;
    line-height: 1.5;
    color: #8898aa !important;
    background-color: #fff;
    background-clip: padding-box;
    border-radius: 0.25rem;
    -webkit-transition: all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55);
    transition: all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55) !important;
    -webkit-box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02) !important;
    box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02);
    border: 0 !important;
    -webkit-transition: -webkit-box-shadow .15s ease;
    transition: -webkit-box-shadow .15s ease;
    transition: box-shadow .15s ease, -webkit-box-shadow .15s ease;
  }
</style>
